import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { Bell } from 'lucide-react';
import { useAppColors } from '@/src/lib/theme';
import { initPush, pushStatus, enablePush } from '@/src/lib/push';

const DISMISS_KEY = 'push-prompt-dismissed';

export default function NotificationPrompt() {
  const c = useAppColors();
  const [show, setShow] = useState(false);

  useEffect(() => {
    void (async () => {
      await initPush();
      let dismissed = false;
      try { dismissed = localStorage.getItem(DISMISS_KEY) === '1'; } catch { /* ignore */ }
      if (!dismissed && (await pushStatus()) === 'prompt') setShow(true);
    })();
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch { /* ignore */ }
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 24 }}
          className="fixed left-4 right-4 z-[70] rounded-2xl p-4 shadow-xl"
          style={{ bottom: 'calc(1rem + env(safe-area-inset-bottom, 0px))', background: c.bg, border: `1px solid ${c.border}` }}
        >
          <div className="flex items-start gap-3">
            <div className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: c.accentBg }}>
              <Bell size={16} style={{ color: c.accentSoft }} />
            </div>
            <div className="flex-1">
              <p className="text-sm font-semibold" style={{ color: c.text }}>Get notified about your tasks</p>
              <p className="text-xs mt-1 leading-relaxed" style={{ color: c.textDim }}>
                New tasks, due reminders, quizzes and end-of-shift reports.
              </p>
              <div className="flex gap-2 mt-3">
                <button onClick={() => { void enablePush().finally(dismiss); }}
                  className="h-9 px-4 rounded-lg text-xs font-semibold" style={{ background: c.accent, color: 'white' }}>
                  Turn on
                </button>
                <button onClick={dismiss} className="h-9 px-4 rounded-lg text-xs font-semibold" style={{ background: c.iconBg, color: c.textDim }}>
                  Not now
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}